import {
  ArrowCircleUpIcon,
  CloudUploadIcon,
  CogIcon,
  FingerPrintIcon,
  LockClosedIcon,
  ServerIcon,
} from '@heroicons/react/outline';
import useTranslation from 'next-translate/useTranslation';

const features = [
  {
    name: 'Easy to install and use.',
    description:
      'Quickly set up our plugins with minimal effort, allowing you to start automating right away without technical hassle.',
    icon: CloudUploadIcon,
  },
  {
    name: 'Save time and reduce manual effort.',
    description:
      'Automate routine operations to boost efficiency, reduce errors, and free your resources for more strategic activities.',
    icon: LockClosedIcon,
  },
  {
    name: 'Enhance your website’s functionality.',
    description:
      'Extend your platform’s capabilities with powerful integrations that improve user experience and operational effectiveness.',
    icon: ArrowCircleUpIcon,
  },
  {
    name: 'Regular updates and support.',
    description:
      'Benefit from ongoing improvements and dedicated support to ensure your plugins stay current and function seamlessly.',
    icon: FingerPrintIcon,
  },
  
];

export default function PluginFeatures() {
  const { t } = useTranslation('b2b');

  return (
    <div className='relative bg-white py-24 dark:bg-slate-900 sm:py-32'>
      <div className='mx-auto max-w-md px-6 text-center sm:max-w-3xl lg:max-w-7xl lg:px-8'>
        <p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
          {t('Powerful Plugins for Effortless Integration')}
        </p>
        <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500 dark:text-slate-400'>
          {t("Easy-to-use plugins that simplify automation and enhance your website's functionality.")}
        </p>
      </div>
     
      <div className='mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8'>
        <dl className='mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base leading-7 text-gray-600 dark:text-slate-400 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:gap-x-8 lg:gap-y-16'>
          {features.map((feature) => (
            <div key={feature.name} className='relative pl-9'>
              <dt className='inline font-semibold text-gray-900 dark:text-slate-200'>
                <feature.icon
                  className='absolute left-1 top-1 h-5 w-5 text-indigo-600'
                  aria-hidden='true'
                />
                {t(feature.name)}
              </dt>{' '}
              <dd className='inline'>{t(feature.description)}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
